import { api } from '@/lib/api/client'

/** `PUT /notifications/read` marks all the caller's notifications read. */
export async function markAllNotificationsRead(): Promise<void> {
  await api.put('/notifications/read')
}
